export default function productTooltipControl() {
  $('.product_item .product_item-img').on('mouseenter', function () {

    var tooltipHolder = $(this);
    var tooltipDupe = tooltipHolder.find('.product-tooltip').clone().appendTo('body');

    var windowWidth = $(window).width();
    var itemTopPosition = tooltipHolder.offset().top;
    var itemLeftPosition = tooltipHolder.offset().left;
    var itemWidth = tooltipHolder.outerWidth(true);
    var tooltipWidth = tooltipDupe.outerWidth(true);
    var itemTooltipOrientation = windowWidth - (itemLeftPosition + itemWidth + tooltipWidth)

    var timeoutID = undefined;

    if (itemTooltipOrientation > 0) {
      tooltipDupe.css({
        top: itemTopPosition,
        left: itemLeftPosition + itemWidth
      });
    } else {
      tooltipDupe.addClass('position-right').css({
        top: itemTopPosition,
        left: itemLeftPosition - tooltipWidth
      });
    }

    tooltipDupe.on('mouseenter', function () {
      if (timeoutID !== undefined) {
        clearTimeout(timeoutID);
        timeoutID = undefined;
      }
    });

    tooltipHolder.on('mouseleave', function () {
      if (timeoutID !== undefined) {
        clearTimeout(timeoutID);
        timeoutID = undefined;
      }

      timeoutID = setTimeout(function () {
        tooltipDupe.remove();
      }, 100);
    });

    tooltipDupe.on('mouseleave', function () {
      if (timeoutID !== undefined) {
        clearTimeout(timeoutID);
        timeoutID = undefined;
      }

      timeoutID = setTimeout(function () {
        tooltipDupe.remove();
      }, 100);
    });
  });
}